module.exports = __webpack_public_path__ + "img/48a73aa976a545c88399d425b44b7353.9aa12f26.png";